import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { IUpdatePricePoliciesPayload } from '../../Services/api/price-policies/price-policies.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdatePricePoliciesUseCase
implements IFormUsecase<IUpdatePricePoliciesPayload, void> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    

  public async handle (
    data: IUpdatePricePoliciesPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.update(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
